class MenuAdjuster {
    constructor(navSelector, dropdownSelector) {
        this.nav = document.querySelector(navSelector);
        this.dropdown = document.querySelector(dropdownSelector);



        // this.nav.parentElement.insertAdjacentHTML('beforeend', '<div class="indicator remover"></div>');
        // this.remover = this.nav.parentElement.querySelector('.remover');
        // this.nav.parentElement.insertAdjacentHTML('beforeend', '<div class="indicator adder"></div>');
        // this.adder = this.nav.parentElement.querySelector('.adder');

        if (!this.dropdown) {
            this.dropdown = document.createElement('li');
            this.dropdown.classList.add('dropdown-menu', 'page-item');
            this.dropdown.setAttribute('tabindex', '0');
            this.dropdown.innerHTML = '<a href="#" tabindex="-1">' + window.string_more + '<div class="ellipses"><span></span><span></span><span></span></div></a><ul class="added-dropdown"></ul>';
            this.nav.appendChild(this.dropdown);
        }

        this.dropdownUl = this.dropdown.querySelector('ul');
        this.moreButtonWidth = this.dropdown.offsetWidth; // Width of the "More" dropdown item

        this.adjustMenu();

        window.addEventListener('resize', () => {
            requestAnimationFrame(() => this.adjustMenu());
        });
        this.adjustMenu();


        const navItems = Array.from(this.nav.children);

        navItems.forEach((item, index) => {
            setTimeout(() => {
                item.style.opacity = 1;
            }, index * 50);
        });
    }

    adjustMenu() {
        // const isNavVisible = this.nav.offsetParent !== null;
        if (this.nav.offsetParent == null) {
            return;
        }
        this.navItems = Array.from(this.nav.querySelectorAll('li:not(.dropdown-menu)'));
        this.navItems.forEach((item, index) => {
            item.setAttribute('data-id', index);
        });
        const navWidth = this.nav.offsetWidth;
        const gap = parseFloat(window.getComputedStyle(this.nav).gap);
        let totalWidth = this.navItems.reduce((total, li, index) => {
            return total + li.offsetWidth + (index > 0 ? gap : 0);
        }, 0);


        if (this.dropdownUl.children.length > 0) {
            totalWidth += this.moreButtonWidth + gap;
        }

        while (totalWidth > navWidth && this.navItems.length > 0) {
            const item = this.navItems.pop();
            let itemWidth = item.offsetWidth;
            this.dropdownUl.insertBefore(item, this.dropdownUl.firstChild);
            totalWidth -= (item.offsetWidth + gap);

        }
        while (totalWidth + (this.dropdownUl.lastChild ? this.dropdownUl.firstChild.offsetWidth - (2 * parseFloat(window.getComputedStyle(this.dropdownUl.firstChild.querySelector('a')).paddingLeft)) + gap : 0) <= navWidth + 2 && this.dropdownUl.children.length > 0) {
            const item = this.dropdownUl.firstChild;
            let itemWidth = item.offsetWidth;
            // console.log(itemWidth)
            itemWidth -= parseFloat(window.getComputedStyle(item).paddingLeft);
            itemWidth -= parseFloat(window.getComputedStyle(item).paddingRight);
            // console.log(itemWidth)
            this.nav.insertBefore(item, this.dropdown)
            totalWidth += (itemWidth + gap);
        }

        // this.adder.style.width = totalWidth + 'px';
        // this.remover.style.width = totalWidth + (this.dropdownUl.lastChild ? this.dropdownUl.lastChild.offsetWidth + gap : 0)  + 'px';
        this.dropdown.style.display = this.dropdownUl.children.length > 0 ? 'block' : 'none';
    }
}

window.onload = function() {
    // if( !jQuery( 'body' ).hasClass('single-game') ){

        const navDropdown = document.querySelector('.nav-dropdown-desktop');
        // console.log(navDropdown)
        if (navDropdown) {
            new MenuAdjuster('.nav-dropdown-desktop ul', '.dropdown-menu');
        }
    //
    // }
}
